<div class="container-fluid">
    <app-report reportId="inventoriesDashboard" screen="DASHBOARDINVENTORIES"></app-report>
</div>
